export default __webpack_public_path__ + "static/media/cqd.e492bf86.svg";